export default __webpack_public_path__ + "static/media/475.ece372f0.png";